import { render, staticRenderFns } from "./GravarVisitaDialog.vue?vue&type=template&id=1fb25d2a&scoped=true&"
import script from "./GravarVisitaDialog.vue?vue&type=script&lang=js&"
export * from "./GravarVisitaDialog.vue?vue&type=script&lang=js&"
import style0 from "./GravarVisitaDialog.vue?vue&type=style&index=0&id=1fb25d2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb25d2a",
  null
  
)

export default component.exports